import React, { ReactElement } from 'react'
import NeedsReviewIcon from 'src/assets/svgs/ReceiptRecoveryNeedsReviewIcon.svg'
import ReceiptReconciledIcon from 'src/assets/svgs/ReceiptRecoveryReconciledIcon.svg'
import WaitingOnSpenderIcon from 'src/assets/svgs/ReceiptRecoveryWaitingOnSpenderIcon.svg'
import { ReceiptState } from 'src/feature/ReceiptRecovery/receiptRecovery.types'

interface CurrentResponsibilityIconProps {
  state: ReceiptState
}

const CurrentResponsibilityIcon = ({
  state,
}: CurrentResponsibilityIconProps): ReactElement => {
  const iconSource =
    state === 'needs-review'
      ? NeedsReviewIcon
      : state === 'waiting-on-spender'
        ? WaitingOnSpenderIcon
        : ReceiptReconciledIcon

  return (
    <span
      aria-hidden="true"
      className={`currentResponsibilityIcon currentResponsibilityIcon--${state}`}
    >
      <img alt="" src={iconSource} />
    </span>
  )
}

export default CurrentResponsibilityIcon
